import React, { PureComponent as Component } from "react";
import ButtonTheme from "css/themes/Buttons.css";
import { Link } from "react-router-dom";
import { Button } from "react-toolbox/lib/button";
import { H4, Small } from "visual-components/util/texts";

export default class GraphEmptyState extends Component {
  render() {
    const {
      text,
      learnMore,
      bigText,
      height = "100%",
      ctaText,
      ctaAction,
      upsellButtonText,
      upsellButtonLink,
      upsellClickHandler,
    } = this.props;

    const TextComponent = bigText ? H4 : Small;

    return (
      <div
        style={{
          display: "flex",
          height,
          flexDirection: "column",
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextComponent cloudGrey multiline>
          <i>
            {text}
            {learnMore && (
              <a href={learnMore} target="_blank">
                {" Learn More"}
              </a>
            )}
          </i>
          {upsellButtonText && (
            <div style={{ marginTop: "20px" }}>
              <Link to={upsellButtonLink}>
                <Button
                  theme={ButtonTheme}
                  className={ButtonTheme.blueButton}
                  onClick={upsellClickHandler}
                >
                  {upsellButtonText}
                </Button>
              </Link>
            </div>
          )}
        </TextComponent>
        {ctaText && (
          <Button
            style={{ marginTop: "16px" }}
            onClick={ctaAction}
            theme={ButtonTheme}
            className={ButtonTheme.blueButton}
            label={ctaText}
            primary
            raised
          />
        )}
      </div>
    );
  }
}
